// COMPANY DIRECTORY — user accounts, hire dates, title overrides, filler photos,
// pay classes, and locations. Lifted VERBATIM from dros-beta-prototype_524.html.
// Feeds the Company screen (Our Team roster) and Company Settings tab.
/* eslint-disable */
// @ts-nocheck

export const USERS =
 [
  { id:'u-001', name:'Joseph Kingston',     email:'joe@diamondridge.com',      personaId:'joe',      role:'admin',      lastLogin:'2026-03-21 17:42', status:'active' },
  { id:'u-002', name:'Bill Hughes',         email:'bhughes@diamondridge.com',  personaId:'bill',     role:'employee',   lastLogin:'2026-03-21 09:12', status:'active' },
  { id:'u-003', name:'Aaron Gardner',       email:'agardner@diamondridge.com', personaId:'aaron',    role:'supervisor', lastLogin:'2026-03-21 14:05', status:'active' },
  { id:'u-004', name:'Ben Hull',            email:'bhull@diamondridge.com',    personaId:'ben',      role:'supervisor', lastLogin:'2026-03-21 16:33', status:'active' },
  { id:'u-005', name:'Chris Hardy',         email:'chardy@diamondridge.com',   personaId:'chris',    role:'employee',   lastLogin:'2026-03-21 11:08', status:'active' },
  { id:'u-006', name:'Martin Morales',      email:'mmorales@diamondridge.com', personaId:'martin',   role:'employee',   lastLogin:'2026-03-20 18:21', status:'active' },
  { id:'u-007', name:'Nathan Kennedy',      email:'nkennedy@diamondridge.com', personaId:'nathan',   role:'employee',   lastLogin:'2026-03-21 07:18', status:'active' },
  { id:'u-008', name:'Johnathan Whitmill',  email:'jwhitmill@diamondridge.com',personaId:'whitmill', role:'employee',   lastLogin:'2026-03-21 13:45', status:'active' },
  { id:'u-009', name:'Nathan Paulson',      email:'npaulson@diamondridge.com', personaId:'whitmill', role:'employee',   lastLogin:'2026-03-21 13:46', status:'active' },
  { id:'u-010', name:'Brady',               email:'brady@diamondridge.com',    personaId:'brady',    role:'trade',      lastLogin:'2026-03-21 18:02', status:'active' },
  { id:'u-011', name:'[Project Lead]',      email:'projectlead@diamondridge.com', personaId:null,    role:'admin',      lastLogin:'2026-03-21 19:30', status:'active' },
  { id:'u-012', name:'Marcus Reyes',        email:'mreyes@diamondridge.com',   personaId:null,       role:'trade',      lastLogin:'never',            status:'pending-onboarding' },
  { id:'u-013', name:'Sarah Chen',          email:'schen@diamondridge.com',    personaId:null,       role:'employee',   lastLogin:'never',            status:'pending-onboarding' },
];

export const EMPLOYEE_START_DATES =
 {
  'u-001': '2024-01-15',   // Joe — founding CEO
  'u-002': '2024-03-10',   // Bill — early hire BD
  'u-003': '2024-04-22',   // Aaron — D&T leadership
  'u-004': '2024-06-15',   // Ben — Sr. Super
  'u-005': '2024-08-01',   // Chris — Sr. PM
  'u-006': '2024-09-12',   // Martin — Sr. Estimator
  'u-007': '2024-11-04',   // Nathan Kennedy — Scheduler
  'u-008': '2025-01-20',   // John Whitmill — FM Handoff
  'u-009': '2025-01-20',   // Nathan Paulson — FM Handoff
  'u-010': '2025-03-15',   // Brady — Trade Foreman
  'u-012': '2026-06-01',   // Marcus — onboarding
  'u-013': '2026-06-03',   // Sarah — onboarding
};

export const EMPLOYEE_TITLE_OVERRIDES =
 {
  'u-009': 'Facility Manager — FM Handoff Team',     // Paulson — same team as Whitmill, distinct title
  'u-012': 'Apprentice Framer',                       // Marcus
  'u-013': 'Junior Estimator',                        // Sarah
};

export const EMPLOYEE_PHOTOS =
 {
  'u-001': 'https://randomuser.me/api/portraits/men/52.jpg',   // Joe — CEO
  'u-002': 'https://randomuser.me/api/portraits/men/41.jpg',   // Bill — Director BD
  'u-003': 'https://randomuser.me/api/portraits/men/32.jpg',   // Aaron — VP D&T
  'u-004': 'https://randomuser.me/api/portraits/men/76.jpg',   // Ben — Sr Super
  'u-005': 'https://randomuser.me/api/portraits/men/15.jpg',   // Chris — Sr PM
  'u-006': 'https://randomuser.me/api/portraits/men/64.jpg',   // Martin — Sr Estimator
  'u-007': 'https://randomuser.me/api/portraits/men/28.jpg',   // Nathan Kennedy — Scheduler
  'u-008': 'https://randomuser.me/api/portraits/men/45.jpg',   // John Whitmill — FM
  'u-009': 'https://randomuser.me/api/portraits/men/83.jpg',   // Nathan Paulson — FM
  'u-010': 'https://randomuser.me/api/portraits/men/91.jpg',   // Brady — Foreman
  'u-012': 'https://randomuser.me/api/portraits/men/11.jpg',   // Marcus — Apprentice
  'u-013': 'https://randomuser.me/api/portraits/women/44.jpg', // Sarah — Junior Estimator
};
